import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import translate from '../_utils/tools/translate';
import get from 'lodash/get';

import BSOverlay from '../_utils/bs-overlay';
import StoreLocator from '../_cart/store-locator';
import CollectionPointLocator from '../_cart/collection-point-locator';
import DeliveryOptionCalculator from '../_utils/_delivery-options/calculator';
import LocationFormatter from './location-formatter';
import Store from '../_utils/tools/store';
import { ZipcodeSelector } from './zipcode-selector';
import { getDeliveryOptionHeadingText } from '../_utils/_delivery-options/header-text';
import { PICKUP_DELIVERY_OPTION_TYPES } from '../../constants/delivery-option-types';

// -----------------------------------------------------------
//  DeliveryOptionsGroupHeader
// -----------------------------------------------------------
const DeliveryOptionsGroupHeader = createReactClass({
  getInitialState: function () {
    return {
      modalOpen: false,
    };
  },
  postalAddressString: function (zipCode, userDetails) {
    if (!zipCode || !userDetails) {
      return '';
    }

    const { addressStreet, addressAdditional, addressCity } = userDetails;
    const address = [addressStreet, addressAdditional, addressCity]
      .filter((line) => line && line.length)
      .join(', ');

    return address.length ? ` ${address}` : '';
  },

  render: function () {
    const {
      heading,
      headingSecond,
      $editLink,
      locator,
      deliveryOptionType,
      availabilityTimestamp,
    } = ((
      { option, locations },
      { zipCode, selectedLocation, userDetails, disableStoreName },
    ) => {
      const { requires_address: requiresAddress } = option;
      const location = new LocationFormatter(
        locations.filter(Boolean).find((l) => l.id == selectedLocation),
      );
      const postalAddress = this.postalAddressString(zipCode, userDetails);
      const deliveryOptionType =
        DeliveryOptionCalculator.deliveryOptionType(option);
      const storeChangeButton = (
        <button
          className="btn btn-outline-info rounded-pill"
          data-test="choose-pickup-store"
          aria-label={`Change ${translate('store')} location`}
          onClick={this.showModal}>
          Change
        </button>
      );
      const availabilityTimestamp = location.pickupTimesFormatted;
      const editLink =
        requiresAddress &&
        !PICKUP_DELIVERY_OPTION_TYPES.includes(deliveryOptionType) ? (
          <ZipcodeSelector />
        ) : (
          storeChangeButton
        );
      const heading = getDeliveryOptionHeadingText({
        deliveryOption: option,
        zipCode,
      });

      switch (deliveryOptionType) {
        case 'PICKUP': {
          if (disableStoreName) {
            return {
              heading,
              headingSecond: '(Select store in checkout)',
              $editLink: '',
              locator: StoreLocator,
              deliveryOptionType,
            };
          }

          const storeHeadingParts = [
            location.name,
            Store.isWalmart() && `#${location.id}`,
          ].filter(Boolean);

          return {
            heading,
            headingSecond:
              location.name &&
              `${storeHeadingParts.join(' ')} ${get(location, 'address.street')}`,
            $editLink: editLink,
            locator: StoreLocator,
            deliveryOptionType,
            availabilityTimestamp,
          };
        }

        case 'COLLECT':
          return {
            heading,
            headingSecond: location.name,
            $editLink: editLink,
            locator: CollectionPointLocator,
            deliveryOptionType,
          };

        case 'POST':
          return {
            heading,
            headingSecond: zipCode
              ? `${zipCode}`
              : `No ${translate('ZIP code')} given`,
            $editLink: editLink,
            deliveryOptionType,
          };

        case 'COURIER':
          return {
            heading,
            headingSecond: postalAddress,
            $editLink: editLink,
            deliveryOptionType,
          };

        case 'POST_EXPRESS':
          return {
            heading,
            headingSecond: postalAddress,
            $editLink: editLink,
            deliveryOptionType,
          };

        case 'COURIER_EXPRESS':
          return {
            heading,
            headingSecond: postalAddress,
            $editLink: editLink,
            deliveryOptionType,
          };

        default:
          return {
            heading,
            deliveryOptionType,
          };
      }
    })(this.props, this.context);

    const iconClassName = `delivery-option-group-header__icon__${deliveryOptionType?.toLowerCase()}`;

    return (
      <div
        className="delivery-options-group-header"
        data-delivery-option={deliveryOptionType || 'not-set'}>
        <div className="row">
          {deliveryOptionType && (
            <div className="col-auto d-flex align-items-start">
              <div
                className={`delivery-options-group-header__icon ${iconClassName}`}></div>
            </div>
          )}

          <div className="col">
            <div className="d-md-flex flex-column">
              <h4 className="mb-1">{heading}</h4>
              {availabilityTimestamp && availabilityTimestamp.length > 0 && (
                <div>
                  <b>Available from:&nbsp;</b>
                  <u>{availabilityTimestamp[0]}</u>
                </div>
              )}
              <div className="d-flex align-items-center justify-content-between justify-content-md-start">
                {headingSecond && (
                  <u className="mr-3" suppressHydrationWarning>
                    {headingSecond}
                  </u>
                )}
                {$editLink}
              </div>
            </div>
          </div>
        </div>
        {locator && this.renderOverlay(locator)}
      </div>
    );
  },

  renderOverlay: function (locator) {
    const $locator = (() => {
      if (this.state.modalOpen) {
        return React.createElement(
          locator,
          Object.assign({}, this.props, { onSelected: this.hideModal }),
        );
      }
    })();

    return (
      <BSOverlay
        extraClassNames="pickup-locator"
        show={this.state.modalOpen}
        onHide={this.hideModal}>
        {$locator}
      </BSOverlay>
    );
  },

  showModal: function (e) {
    e.preventDefault();

    this.setState({
      modalOpen: true,
    });
  },
  hideModal: function (e) {
    this.setState({
      modalOpen: false,
    });
  },
});

DeliveryOptionsGroupHeader.contextTypes = {
  zipCode: PropTypes.string,
  selectedLocation: PropTypes.string,
  disableStoreName: PropTypes.bool,
  userDetails: PropTypes.object,
};

export default DeliveryOptionsGroupHeader;
